import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Play, Lock, FileVideo } from 'lucide-react'

interface EpisodeCardProps {
  moduleId: number // ID real do módulo no banco (para navegação)
  moduleOrder?: number // Ordem de exibição (1, 2, 3...)
  episodeNumber: number
  title: string
  duration?: string
  thumbnailUrl?: string
}

const EpisodeCard = ({
  moduleId,
  moduleOrder,
  episodeNumber,
  title,
  duration,
  thumbnailUrl,
}: EpisodeCardProps) => {
  const [imageError, setImageError] = useState(false)
  const displayOrder = moduleOrder || moduleId // Usa moduleOrder se fornecido, senão usa moduleId
  const isLocked = displayOrder === 4 || displayOrder === 5

  const CardContent = (
    <>
      <div className="aspect-video bg-black relative overflow-hidden flex items-center justify-center">
        {thumbnailUrl && !imageError ? (
          /* Imagem do episódio */
          <img
            src={thumbnailUrl}
            alt={title}
            className="w-full h-full object-cover"
            onError={() => setImageError(true)}
          />
        ) : (
          /* Placeholder icon se não tiver thumbnail ou se der erro */
          <FileVideo
            className={`w-24 h-24 transition-all duration-300 ${
              isLocked
                ? 'text-muted-foreground/40'
                : 'text-primary drop-shadow-[0_0_15px_rgba(249,115,22,0.5)] group-hover:drop-shadow-[0_0_25px_rgba(249,115,22,0.8)] group-hover:scale-110'
            }`}
            strokeWidth={1.5}
          />
        )}

        {/* Play button overlay */}
        <div
          className={`absolute inset-0 ${!isLocked ? 'group-hover:bg-black/30' : ''} transition-colors duration-300 flex items-center justify-center`}
        >
          {isLocked ? (
            <div className="absolute bottom-3 right-3 w-8 h-8 rounded-full bg-muted-foreground/60 flex items-center justify-center shadow-lg">
              <Lock className="w-4 h-4 text-muted" />
            </div>
          ) : (
            <div className="absolute bottom-3 right-3 w-8 h-8 rounded-full bg-primary flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-[0_0_15px_rgba(249,115,22,0.5)]">
              <Play className="w-4 h-4 text-white fill-white" />
            </div>
          )}
        </div>
      </div>
      <div className="p-4 bg-card border-t border-border">
        <h4
          className={`text-sm font-medium line-clamp-2 transition-colors duration-200 ${isLocked ? 'text-muted-foreground' : 'text-foreground group-hover:text-primary'}`}
        >
          Ep {displayOrder}.{episodeNumber} - {title}
        </h4>
      </div>
    </>
  )

  if (isLocked) {
    return (
      <div className="bg-card border border-border rounded-lg overflow-hidden cursor-not-allowed opacity-75 hover:shadow-lg transition-shadow duration-300">
        {CardContent}
      </div>
    )
  }

  return (
    <Link
      to={`/episode/${moduleId}/${episodeNumber}`}
      className="bg-card border border-border rounded-lg overflow-hidden group hover:border-primary hover:shadow-lg hover:shadow-primary/20 transition-all duration-300"
    >
      {CardContent}
    </Link>
  )
}

export default EpisodeCard
